let Document = {
    globalLoadingStart: () => {
        document.querySelector("#global-loading-wrap").style.display = 'block'
    },
    globalLoadingStop: () => {
        document.querySelector("#global-loading-wrap").style.display = 'none'
    },
}

export default {
    install(Vue) {
        Vue.$Document = Vue.prototype.$Document = Document
    }
}